import { Button } from 'antd'
import { ButtonProps } from 'antd'
import clsx from 'clsx'
import styles from './index.module.scss'
import { LanguageEnum } from '../../until'

export const ButtonCommon = ({ ...props }: ButtonProps) => {
  return (
    <div className={clsx(styles.button__container, { [styles.transparent]: props.type === 'ghost' })}>
      <Button 
        {...props} 
        className={clsx(
          props.className,
          { 'lang-en-spacing': props.lang === LanguageEnum.ENGLISH },
          { 'lang-ja-spacing': props.lang === LanguageEnum.JAPANESE }
        )}
      />
    </div>
  )
}
